import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  Label,
  Modal,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
} from "reactstrap";
import {
  GET_DT_BALANCE_COLUMN,
  GET_DT_BALANCE_ZONE,
  GET_SHIPPER,
  GET_SHIPPER_BY_BOOKING
} from "helpers/url_api_constant";
import { Link, useHistory } from "react-router-dom";
import React, { useEffect, useState } from "react";

import BalancingEnergy from "./tab/BalancingEnergy";
import BalancingVolumn from "./tab/BalancingVolumn";
import BootstrapTable from "react-bootstrap-table-next";
import { DatePicker } from "antd";
import Flatpickr from "react-flatpickr";
import ManageColumn from "./dialog/ManageColumn";
import ManageShipper from "./dialog/ManageShipper";
import ManageZone from "./dialog/ManageZone";
import MinInventory from "./tab/MinInventory";
import PropTypes from "prop-types";
import Select from "react-select";
import cellEditFactory from "react-bootstrap-table2-editor";
import classnames from "classnames";
import { connect } from "react-redux";
import { getPermission } from "./../../../helpers/auth_helper";
import moment from "moment";
import { post } from "helpers/api_helper";
import { withTranslation } from "react-i18next";

//i18n
function Balancing_ShrinkgateGasData(props) {
  const permission = getPermission();
  const [activeTab, setActiveTab] = useState("1");
  const [showManageColumn, setShowManageColumn] = useState(false);
  const [showManageZone, setShowManageZone] = useState(false);
  const [showManageShipper, setShowManageShipper] = useState(false);
  const [dateSelected, setDateSelected] = useState(moment().add(-1, 'day').toDate());
  const [columnList, setColumnList] = useState([]);
  const [zoneList, setZoneList] = useState([]);
  const [shipperList, setShipperList] = useState([]);
  //sort Column//
  const defaultSorted = [
    {
      dataField: "Id",
      order: "asc",
    },
  ];

  //headerColumn
  function disabledDate(current) {
    // Can not select days before today and today
    return current && current > moment().endOf("day");
  }
  const getColumn = () => post(GET_DT_BALANCE_COLUMN, {});
  const getBalanceZone = () => post(GET_DT_BALANCE_ZONE, {});
  const getSystemShipper = () => post(GET_SHIPPER, { });
  const getSystemShipper2 = () => post(GET_SHIPPER_BY_BOOKING, { LOAD_DATE: moment(dateSelected).format("YYYY-MM-DD")});
  // const getBalanceShipper = () => post(GET_DT_BALANCE_SHIPPER, {});
  //onInit//

  useEffect(() => {
    getTableData();
  }, [dateSelected]);
  const getTableData = async () => {
    // console.log(1);
    try {
      let [col, zone, shipperMaster,sysShipper2] = await Promise.all([
        getColumn(),
        getBalanceZone(),
        getSystemShipper(),
        getSystemShipper2()
      ]);

      
      let  sysShipper = sysShipper2.data.shipperDataList.map(row => {

          let temp=shipperMaster.data.customerList.find(obj => obj.CONTACT_CODE==row.SHIPPER_CODE );

          return{ SHIPPER_NAME: row.SHIPPER_NAME, PID: temp?.PID,CONTACT_CODE:row.SHIPPER_CODE }
        })
  // console.log(sysShipper,sysShipper2)
      setShipperList(sysShipper);
      setColumnList(
        col.data.dtBalanceColumnList
          .sort((a, b) =>
            a.BALANCECOLUMN_ORDER > b.BALANCECOLUMN_ORDER
              ? 1
              : b.BALANCECOLUMN_ORDER > a.BALANCECOLUMN_ORDER
                ? -1
                : 0
          )
          .filter(row => row.BALANCECOLUMN_SHOW == true)
      );
      setZoneList(
        zone.data.dtBalanceList
          .sort((a, b) =>
            a.BALANCEZONE_ORDER > b.BALANCEZONE_ORDER
              ? 1
              : b.BALANCEZONE_ORDER > a.BALANCEZONE_ORDER
                ? -1
                : 0
          )
          .filter(row => row.BALANCEZONE_SHOW == true)
      );
    } catch (error) { 
      console.log(error)
    }
  };
  //onInit//

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Row>
            <Col xl="12">
              {/* <Card>
                <CardBody>
              
                  <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                    <h1 className="mb-sm-0 font-size-20">
                      {" "}
                      {props.t("Balancing & Shrinkgate Gas Data")}
                    </h1>
                    <div className="page-title-right">
                      <ol className="breadcrumb m-0">
                        <li className="breadcrumb-item">
                          <Link to="#" style={{ color: "#556ee6" }}>
                            Manual Data Entry
                          </Link>
                        </li>
                        <li className="breadcrumb-item active">
                          Balancing & Shrinkgate Gas Data
                        </li>
                      </ol>
                    </div>
                  </div>
                </CardBody>
              </Card> */}

              <Row>
                <Col sm="12">
                  <Card>
                    <CardBody>
                      <Row>
                        <Col sm="12">
                          <FormGroup className="row">
                            <div className=" d-flex align-items-center justify-content-end">
                              <h5> Data Month : </h5>
                              <DatePicker
                                style={{ width: 200, marginLeft: 20 }}
                                defaultValue={moment(dateSelected)}
                                format={"MMMM YYYY"}
                                onChange={(date, dateString) => {
                                  if (date != null) {
                                    setDateSelected(date.toDate());
                                  }
                                }}
                                picker="month"
                                disabledDate={disabledDate}
                              />
                            </div>
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row className="mt-4">
                        <hr />
                      </Row>
                      {permission.mMIM && (
                        <Row className="mt-2 mb-2">
                          <Col sm="12">
                            <FormGroup className="row ">
                              <div className="d-flex justify-content-end">

                                {activeTab != 3 ?
                                  <>
                                    <button
                                      type="button"
                                      className="btn btn-primary me-2"
                                      onClick={() => setShowManageColumn(true)}
                                    >
                                      &nbsp; Manage Column
                                    </button>

                                    {/* <button
                                    type="button"
                                    className="btn btn-primary me-2"
                                    onClick={() => setShowManageShipper(true)}
                                  >
                                    &nbsp; Manage Shipper
                                  </button> */}
                                  </> :
                                  <div style={{ height: "36.54px" }}></div>
                                }
                                <button
                                  type="button"
                                  className="btn btn-primary me-2"
                                  onClick={() => setShowManageZone(true)}
                                >
                                  &nbsp; Manage Zone
                                </button>
                              </div>
                            </FormGroup>
                          </Col>
                        </Row>
                      )}

                      <Row>
                        <Nav tabs>
                          <NavItem>
                            <NavLink
                              style={{ cursor: "pointer" }}
                              className={classnames({
                                active: activeTab === "1",
                              })}
                              onClick={() => {
                                setActiveTab("1");
                              }}
                            >
                              Balancing & Shrinkage Gas Data (Energy)
                            </NavLink>
                          </NavItem>
                          <NavItem>
                            <NavLink
                              style={{ cursor: "pointer" }}
                              className={classnames({
                                active: activeTab === "2",
                              })}
                              onClick={() => {
                                setActiveTab("2");
                              }}
                            >
                              Balancing & Shrinkage Gas Data (Volume)
                            </NavLink>
                          </NavItem>
                          <NavItem>
                            <NavLink
                              style={{ cursor: "pointer" }}
                              className={classnames({
                                active: activeTab === "3",
                              })}
                              onClick={() => {
                                setActiveTab("3");
                              }}
                            >
                              Min Inventory
                            </NavLink>
                          </NavItem>
                        </Nav>
                      </Row>

                      <Row>
                        <TabContent
                          activeTab={activeTab}
                          className="p-3 text-muted"
                        >
                          <TabPane tabId="1">
                            <BalancingEnergy
                              dateSelected={dateSelected}
                              column={columnList}
                              zone={zoneList}
                              shipper={shipperList}
                            />
                          </TabPane>

                          <TabPane tabId="2">
                            <BalancingVolumn
                              dateSelected={dateSelected}
                              column={columnList}
                              zone={zoneList}
                              shipper={shipperList}
                            />
                          </TabPane>

                          <TabPane tabId="3">
                            <MinInventory
                              dateSelected={dateSelected}
                              column={[{
                                // "PID": "b6528e52-74da-4710-87bb-e64a33b091fe",
                                "BALANCECOLUMN_ORDER": 1,
                                "BALANCECOLUMN_NAME": "Min Inventory",
                                // "BALANCECOLUMN_DESC": "FUEL",
                                "BALANCECOLUMN_SHOW": true,
                                "PRIORITY_FLAG": 0,
                                "STATUS_FLAG": 0,
                                // "CREATE_USER": "test",
                                // "CREATE_DATE": "2022-02-11T14:28:40.457",
                                // "UPDATE_USER": "test",
                                // "UPDATE_DATE": "2022-02-28T14:14:56.62"
                              }]}
                              zone={zoneList}
                              shipper={shipperList}
                            />
                          </TabPane>
                        </TabContent>
                      </Row>

                      {/* <hr /> */}
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      </div>
      <ManageColumn
        show={showManageColumn}
        hide={() => setShowManageColumn(false)}
        onChange={() => getTableData()}
      />
      <ManageZone
        show={showManageZone}
        hide={() => {
          setShowManageZone(false);
        }}
        onChange={() => getTableData()}
      />
      {/* <ManageShipper
        show={showManageShipper}
        hide={() => setShowManageShipper(false)}
        onChange={() => getTableData()}
      /> */}
      {/*end : PageAdd */}
    </React.Fragment>
  );
}

Balancing_ShrinkgateGasData.propTypes = {
  t: PropTypes.any,
};

const mapStateToProps = ({ Balancing_ShrinkgateGasData }) => ({});

const mapDispatchToProps = dispatch => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(Balancing_ShrinkgateGasData));
